<template>
    <div>
        <UserTable></UserTable>
    </div>
</template>

<script>
import UserTable from '../../components/Admin/Component/UserTable.vue'
export default {
    name: 'PadmawebUserView',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
    components:{
        UserTable
    }
};
</script>

<style lang="scss" scoped>

</style>